import Ipads from './Ipads';

export default Ipads;
